// extracted by mini-css-extract-plugin
export var actionText = "_np-4";
export var container = "_np-0";
export var leftSection = "_np-1";
export var rightSection = "_np-2";
export var settingsButton = "_np-6";
export var settingsIcon = "_np-7";
export var shortcut = "_np-5";
export var shortcutGroup = "_np-3";